import React, { ReactNode, useEffect, useState } from "react";
import { desktop, tablet } from "./BreakPoints";

type DeviceViewProps = {
  mobile?: ReactNode;
  tablet?: ReactNode;
  desktop?: ReactNode;
}


export function DeviceView(props:DeviceViewProps): JSX.Element {
    const [screenSize, setScreenSize] = useState('');
  
    useEffect(() => {
      const handleResize = () => {
        const width = window.innerWidth;
        if (width <= tablet) {
          setScreenSize('mobile');
        } else if (width <= desktop) {
          setScreenSize('tablet');
        } else {
          setScreenSize('desktop');
        }
      };
  
      handleResize();
      window.addEventListener('resize', handleResize);
  
      // Ryd eventlistener ved unmount
      return () => window.removeEventListener('resize', handleResize);
      
    }, []);
  
    
    switch (screenSize) {
      case 'mobile':
          return <>{props.mobile}</>;
      case 'tablet':
          return <>{props.tablet}</>;
      case 'desktop':
          return <>{props.desktop}</>;
      default:
          return null;
  }
  }